import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrap"
}
const _hoisted_2 = { class: "content" }

import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import CommonHeader from '@/components/CommonHeader.vue'
import { autoLogoutIfTokenExpired } from '@/utils/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const isLoginPage = computed(() => {
  return route.name === 'Login'
})

onMounted(() => {
  autoLogoutIfTokenExpired();
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (!isLoginPage.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CommonHeader),
        _createElementVNode("main", _hoisted_2, [
          _createVNode(_component_router_view)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}
}

})